<!-- section start -->
<section class="single-blog-head bg-webp" data-image-src="assets/images/breadcrumb" style="background-image:url('./assets/images/breadcrumb.jpg')">
    <div class="container">
        <div class="row m-t-50 m-b-0">
            <div class="col-12">
                <div class="title title2 title-inner">
                    <div class="main-title">
                        <h2 class="borders text-center color-000"><span>Insta360 One X</span></h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="agency blog-sec blog-sidebar single_blog_item">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2">
                <div class="box-iframe">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" src="https://www.google.com/maps/embed?pb=!4v1583724152954!6m8!1m7!1sCAoSLEFGMVFpcE1BMFc0dktaWWlRTWZZbHVncjNUUndKYThPaU5GQXVQeC1nSzI5!2m2!1d46.45499601732211!2d9.792111982754761!3f83.87!4f-0.519999999999996!5f0.7820865974627469"></iframe>
                    </div>
                </div>
            </div>
        </div>        
        <div class="blog-text">
            <h3 class="blog-head text-center">Street View created with Insta360 One X</h3>
            <div class="blog-divider"></div>
            <div class="blog-description border-0 pb-0">
                <!-- TEXT HERE -->
            </div>
        </div>
    </div>
</section>
<!-- section start -->